"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _utils = require("../../utils");

var _header = _interopRequireDefault(require("../../components/header"));

var _excluded = ["fontSize", "tag"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  // Font size css style system prop
  fontSize: _utils.stylePropType,
  // Polymorphic prop that determines what's ultimately being rendered
  tag: _propTypes.elementType
};
var defaultProps = {
  fontSize: 6,
  tag: "h3"
};

var SubHead = function SubHead(_ref) {
  var fontSize = _ref.fontSize,
      tag = _ref.tag,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_header["default"], _extends({
    fontSize: fontSize,
    tag: tag
  }, props));
};

SubHead.defaultProps = defaultProps;
SubHead.propTypes = propTypes;
var _default = SubHead;
exports["default"] = _default;